import {
  Button,
  GroupTextField,
  GroupTextFieldRow,
  Heading,
} from "@elaniintc/goes-design-system";
import { ScopeField } from "../components/scope-selector";
import SwitchField from "../../form/components/SwitchField";
import { DCCondition } from "../components/condition";
import { TypeValueInput } from "../components/ValueInput";
import { useDataCenterNode } from "../context";
import { useGetVariables } from "@/workflow_api/hooks/variables/useGetVariables";
import { mapValueInputTypeToVariableType } from "../types";

export const DCUpdateForm = () => {
  const {
    columns,
    columnsDef,
    setColumns,
    setMultipleSelected,
    multipleSelected,
  } = useDataCenterNode();
  const { variables } = useGetVariables();

  const updateColumninputType = (
    name: string,
    inputType: "input" | "variable",
  ) => {
    setColumns(
      columns.map((col) =>
        col.name === name ? { ...col, inputType, value: "" } : col,
      ),
    );
  };

  return (
    <div className="w-full">
      <div className="w-full pt-3 pb-6 px-4 border-b-1 border-neutral-quiet flex flex-col gap-1">
        <Heading variant="h6">Búsqueda de registros</Heading>
        <div className="flex flex-col gap-4">
          <ScopeField />
          <DCCondition className="p-0" buttonSize="xs" variables={columnsDef} />
          <SwitchField
            label="Múltiples actualizaciones"
            checked={multipleSelected}
            onChange={setMultipleSelected}
            required
            switchVariant="danger"
            isFalse="No, solo el primer registro que haga match"
          />
        </div>
      </div>
      <div className="w-full pt-3 pb-6 px-4 border-b-1 border-neutral-quiet flex flex-col gap-2">
        <Heading variant="h6">Datos para sobreescribir</Heading>
        {columns.map((column) => (
          <GroupTextField
            key={column.name}
            label={column.label}
            required={column.isRequired}
            labelHelperText={column.isRequired ? "" : "Opcional"}
            className="w-full flex-auto"
          >
            <GroupTextFieldRow>
              <Button
                variant="quiet"
                type="button"
                className="font-mono"
                onClick={() =>
                  updateColumninputType(
                    column.name,
                    column.inputType === "input" ? "variable" : "input",
                  )
                }
              >
                {column.inputType === "input" ? "inp" : "var"}
              </Button>
              <TypeValueInput
                inputType={column.inputType}
                valueType={column.valueType}
                value={column.value}
                placeholder={column.placeholder}
                onValueChange={(value) =>
                  setColumns(
                    columns.map((col) =>
                      col.name === column.name ? { ...col, value } : col,
                    ),
                  )
                }
                inputVariables={variables}
                group="right"
                filterByType={mapValueInputTypeToVariableType(column.valueType)}
              />
            </GroupTextFieldRow>
          </GroupTextField>
        ))}
      </div>
    </div>
  );
};
